import React from "react";
import { IconCalendar, IconChevronRight } from "../Icons";
import { TimeOption } from "./TimeOption";
export const TimeOptions = ({ active, timeOptions, onSelect, align }) => {
    return (React.createElement("div", { style: { flex: 1 } },
        timeOptions.map((timeOption, index) => (React.createElement(TimeOption, Object.assign({ active: timeOption === active, key: index, onSelect: (value) => onSelect(timeOption, value) }, timeOption)))),
        React.createElement("div", { className: [
                "tnic-timeOption",
                (active === null || active === void 0 ? void 0 : active.type) === "absolute" && "tnic-timeOption--active",
            ]
                .filter(Boolean)
                .join(" "), onClick: () => onSelect({
                type: "absolute",
            }) },
            React.createElement("span", null,
                React.createElement("span", { style: { marginRight: "1em" } },
                    React.createElement(IconCalendar, null)),
                "Enter Custom Range"),
            align !== "right" && React.createElement(IconChevronRight, null))));
};
//# sourceMappingURL=TimeOptions.js.map